import React from 'react';
import { SxProps } from '@mui/system';
import { Box } from '@mui/material';
import SplineChart from 'src/components/BeaconV2Components/SplineChart/SplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

export function SlCardContainer({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        ...sx
      }}
    >
      {children}
    </Box>
  );
}

export function SlCardHeader({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <Box
      sx={{
        paddingTop: '16px',
        paddingLeft: '16px',
        paddingRight: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        ...sx
      }}
    >
      {children}
    </Box>
  );
}

export function SlCardFooter({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <>
      <div style={{ flex: 1 }}></div>
      <Box
        sx={{
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingBottom: '16px',
          ...sx
        }}
      >
        {children}
      </Box>
    </>
  );
}

export function SlCardTitle({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <Box
      sx={{
        fontSize: '16px',
        fontWeight: 500,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        ...sx
      }}
    >
      {children}
    </Box>
  );
}

export function SlCardSplineChart({
  metricType,
  primaryData,
  secondaryData,
  width,
  height = 64,
  sx
}: {
  metricType: METRICTYPE;
  primaryData: number[][];
  secondaryData?: number[][];
  width: number;
  height: number;
  sx?: SxProps;
}) {
  return (
    <Box
      sx={{
        marginTop: '92px',
        ...sx
      }}
    >
      <SplineChart
        preview={{
          width,
          height
        }}
        removeSpacing
        metricType={metricType}
        primaryData={primaryData}
        secondaryData={secondaryData}
        chartOptionsOverride={{
          plotOptions: {
            series: {
              lineWidth: 2
            }
          }
        }}
      />
    </Box>
  );
}

export function SlCardBack({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return (
    <Box
      sx={{
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        ...sx
      }}
    >
      {children}
    </Box>
  );
}
